// Mock data for DSL Jamaica Cleaning Services

export const services = [
  {
    id: 1,
    title: "Commercial Cleaning",
    description: "Professional cleaning solutions for offices, retail spaces, and commercial buildings. We ensure your business maintains a pristine appearance.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1652739267757-a316c778067c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjbGVhbmluZyUyMHdvcmtlcnN8ZW58MHx8fHwxNzY2MjkzOTYwfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Domestic Cleaning",
    description: "Comprehensive home cleaning services tailored to your needs. From routine maintenance to deep cleaning, we've got you covered.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1758273238368-1e2ada245183?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjbGVhbmluZyUyMGVxdWlwbWVudHxlbnwwfHx8fDE3NjYyOTM5NzN8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Waste Disposal & Management",
    description: "Efficient waste collection and disposal services. We handle all types of waste with environmentally responsible practices.",
    icon: "Trash2",
    image: "https://images.unsplash.com/photo-1574974671999-24b7dfbb0d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx3YXN0ZSUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzY2MjY2NjcwfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Deep Cleaning",
    description: "Intensive cleaning services for a thorough refresh of your space. Perfect for seasonal cleaning or special occasions.",
    icon: "Sparkles",
    image: "https://images.pexels.com/photos/4239035/pexels-photo-4239035.jpeg"
  },
  {
    id: 5,
    title: "Post-Construction Cleaning",
    description: "Specialized cleaning for newly constructed or renovated properties. We remove dust, debris, and prepare your space for use.",
    icon: "HardHat",
    image: "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzY2MjY2NjU5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Event Cleanup",
    description: "Pre and post-event cleaning services. We ensure your venue is spotless before and after your special occasion.",
    icon: "Calendar",
    image: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMGNsZWFuaW5nfGVufDB8fHx8MTc2NjI2NjY2NXww&ixlib=rb-4.1.0&q=85"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Business Owner",
    content: "DSL Jamaica has been maintaining our office for over a year. Their attention to detail and professionalism is outstanding!",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Thompson",
    role: "Property Manager",
    content: "Reliable, efficient, and thorough. The team at DSL Jamaica exceeds our expectations every single time.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Brown",
    role: "Homeowner",
    content: "The deep cleaning service transformed our home. Highly professional and eco-friendly approach. Highly recommend!",
    rating: 5
  }
];

export const bookings = [];

export const contactSubmissions = [];
